import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { initialsOf } from '../lib/format';
import { config } from '../config';
import { toDisplayVersion } from '../utils/displayVersion';
import { APEXIA_LOGO_URL } from '../constants/brand';
import TierSwitch from './TierSwitch';

const NAV = [
  { to: '/', label: 'Home', end: true },
  { to: '/clients', label: 'Clients', end: false },
  { to: '/reps', label: 'Reps', end: false },
  { to: '/support', label: 'Support', end: false },
  { to: '/actions', label: 'Actions', end: false }
];

export default function Topbar() {
  const { user, logout } = useAuth();
  const name = user?.displayName || user?.email || 'Admin';

  return (
    <div className="topbar">
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <div className="brand">
          <img className="brand-mark" src={APEXIA_LOGO_URL} alt="" />
          <span>Apexia Labs</span>
        </div>
        <nav className="nav">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => (isActive ? 'active' : '')}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </div>
      <div className="top-right">
        <TierSwitch />
        {/* Build version — release number only; hover shows the full build id */}
        <span className="version-badge" title={`build ${config.app.version}`}>
          v{toDisplayVersion(config.app.version)}
        </span>
        <button className="btn" onClick={() => logout()}>
          Sign out
        </button>
        <span className="avatar" title={name}>
          {initialsOf(name)}
        </span>
      </div>
    </div>
  );
}
